import { Component, forwardRef, Output, EventEmitter } from '@angular/core';
import { Validator, ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, AbstractControl, ValidationErrors } from '@angular/forms';
import { Contact, emptyContact } from '../interfaces/establishments.interfaces';

@Component({
  selector: 'ch-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ContactsListComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ContactsListComponent),
      multi: true,
    },
  ],
})
export class ContactsListComponent implements ControlValueAccessor, Validator {
  @Output() cancel: EventEmitter<void> = new EventEmitter();

  private _contact: Contact = emptyContact();

  onChange = (_: any) => {};
  onTouched = () => {};

  constructor() {}

  set contact(newContact: Contact) {
    this.writeValue(newContact);
    this.onChange(newContact);
  }

  get contact(): Contact {
    return this._contact;
  }

  writeValue(newElement: any): void {
    if (newElement !== this._contact) {
      this._contact = newElement;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(_: boolean): void {}

  validate(_: AbstractControl): ValidationErrors {
    return this.contact && this.contact.value ? null : { nameRequired: { valid: false } };
  }

  deleteContact() {
    this.cancel.emit();
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/offers/contact/contact.component.ts